import { render, staticRenderFns } from "./DisabilitiesEdit.vue?vue&type=template&id=03c9bfe4&scoped=true&"
import script from "./DisabilitiesEdit.vue?vue&type=script&lang=js&"
export * from "./DisabilitiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9bfe4",
  null
  
)

export default component.exports